import {
    COMPANIES_FETCH,
    COMPANIES_IS_FETCING,
    COMPANIES_API,
    COMPANY_EDIT,
    COMPANY_FILTER,
} from 'constants/companies'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

//Save Companies
export const companySave = (data) => (dispatch, state) => {
    let action;
    if (data.companyId)
        action = put;
    else
        action = post;
    dispatch(companiesIsFetching(true))
    return action(COMPANIES_API, data)
        .then((e) => { dispatch(companiesIsFetching(false)); return e; })
        .catch((e) => { dispatch(companiesIsFetching(false)); throw new Error(e) })
}



//Feth company by id
export const companyFetch = (id) => (dispatch, state) => {
        dispatch(companiesIsFetching(true));
        return get(COMPANIES_API + '/' + id)
            .finally(e => dispatch(companiesIsFetching(false)))

    }
    //Feth all companies
export const companiesFetch = () => (dispatch, state) => {
    dispatch(companiesIsFetching(true));
    const filter = state().companies.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    return get(COMPANIES_API, {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        })
        //Array->Obj[companyId]{...companyinformation}
        //for easy access of company by his id
        .then((e) => {
            dispatch(companiesFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                companyFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(companiesIsFetching(false)))

}


//Remove one company
export const companyRemove = (id) => (dispatch, state) => {
    dispatch(companiesIsFetching(true))
    return remove(COMPANIES_API + '/' + id)
        //Array->Obj[companyId]{...companyinformation}
        //for easy access of company by his id
        .finally(e => dispatch(companiesIsFetching(false)))


}
export const companiesFetched = (payload) => ({ type: COMPANIES_FETCH, payload: payload })
export const companiesIsFetching = (payload) => ({ type: COMPANIES_IS_FETCING, payload: payload })
export const companyEdit = (id, data) => ({ type: COMPANY_EDIT, payload: data })
export const companyFilter = (data) => ({ type: COMPANY_FILTER, payload: data })


// WEBPACK FOOTER //
// ./src/actions/companies.js